import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_ALLOW_GENERAL_ROLE_APPLICATIONS } from './allow-general-role-applications.gql';

export function AllowGeneralRoleApplications() {
  const [queryAllowGeneralRoleApplications] = useCampfireLazyQuery<any, {}>(GET_ALLOW_GENERAL_ROLE_APPLICATIONS);
  const [enabled, setEnabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryAllowGeneralRoleApplications({}).then((response) =>
      setEnabled(
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue ?? false
      )
    );
  }, []);

  const saveFetch = useCampfireFetch({ defer: true });
  const apiUrl = useApiUrl();

  const onSave = () => {
    saveFetch
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'allow-general-role-applications',
          value: !enabled,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setEnabled(!enabled);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(enabled)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'allow general role applications toggle' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Allow General Role Applications
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            Let existing volunteers apply for roles outside of the onboarding flow via the Roles tab.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
